import { render, staticRenderFns } from "./surpass.vue?vue&type=template&id=484bee90&scoped=true"
import script from "./surpass.vue?vue&type=script&lang=js"
export * from "./surpass.vue?vue&type=script&lang=js"
import style0 from "./../style.scss?vue&type=style&index=0&id=484bee90&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484bee90",
  null
  
)

export default component.exports